import { render } from "./Backlog.vue?vue&type=template&id=73cbf4c2&scoped=true&ts=true"
import script from "./Backlog.vue?vue&type=script&lang=ts"
export * from "./Backlog.vue?vue&type=script&lang=ts"

import "./Backlog.vue?vue&type=style&index=0&id=73cbf4c2&scoped=true&lang=css"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cbf4c2"]])

export default __exports__